import { DatiUIU } from './../../model/dati-uiu.model';
import * as DatiUIUActions from '../actions/dati-uiu.actions';



export function datiUIUReducer(state: DatiUIU = new DatiUIU(), action) {
  switch (action.type) {
    case DatiUIUActions.SET_DATI_UIU:
        return action.payload;
    default:
        return state;
    }
}